import { render, staticRenderFns } from "./allowHalf-editor.vue?vue&type=template&id=2fd32af4&scoped=true&"
import script from "./allowHalf-editor.vue?vue&type=script&lang=js&"
export * from "./allowHalf-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd32af4",
  null
  
)

export default component.exports